import { useState } from 'react';
import FAQ from '../content/faq';
import site from '../content/site';
import Reveal from './Reveal';

export default function Faq() {
  const [open, setOpen] = useState(0); // -1 = none

  return (
    <section aria-labelledby="faq-h" className="container-site pt-sec-y">
      <div className="grid gap-x-10 gap-y-8 nav:grid-cols-[minmax(0,4fr)_minmax(0,8fr)]">
        <Reveal>
          <h2 id="faq-h" className="text-h2">FAQ</h2>
          <p className="mt-5 text-[16px]">
            Something else? <a href={`mailto:${site.email}`} className="border-b-2 border-current font-semibold text-accent-700">Email us</a>
          </p>
        </Reveal>
        <div className="border-t-2 border-ink">
          {FAQ.map((f, k) => {
            const on = open === k;
            return (
              <div key={f.q} className="border-b-2 border-ink">
                <h3>
                  <button
                    type="button" aria-expanded={on} aria-controls={`faq-${k}`} onClick={() => setOpen(on ? -1 : k)}
                    className="flex w-full items-center justify-between gap-6 py-[22px] text-left text-[clamp(19px,1.7vw,23px)] font-extrabold tracking-[-0.015em] transition-colors hover:text-accent"
                  >
                    <span>{f.q}</span>
                    <span aria-hidden="true" className={`grid h-9 w-9 flex-none place-items-center text-[22px] leading-none text-bg ${on ? 'bg-accent' : 'bg-ink'}`}>{on ? '−' : '+'}</span>
                  </button>
                </h3>
                {on && <div id={`faq-${k}`} role="region" className="pretty pb-6 pr-[60px] text-body text-neutral-800">{f.a}</div>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
